import { Link } from '@reach/router';
import { formatCurrency } from 'js/services/Format';
import React from 'react';
import UserCountry from 'js/services/UserCountry';

const activityClass = (type) => {
  switch (type) {
    case 'offer':
      return 'order';
    default:
      return type;
  }
};

const statusDescription = (status) => {
  switch (status) {
    case 'order_completed':
      return 'Completed';
    case 'accepted_by_seller':
      return 'Accepted by Seller';
    case 'not_accepted_by_seller':
      return 'Not Accepted by Seller';
    default:
      return status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  }
};

const Activity = ({ activity, onCopy, copied }) => {

  const copyText = (alias, url) => {
    onCopy({ item: alias, text: url });
  };

  /**
   * Stores the icons to show according to the different activity type
   * TODO: define what each activity means
   */
  const Iconography = {
    // Ofers
    'token': <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 21 21'>
      <path
        d='M11.975 19.575c-.3.3-.662.45-1.088.45-.425 0-.787-.15-1.087-.45L.425 10.2a1.312 1.312 0 0 1-.337-.525A1.885 1.885 0 0 1 0 9.1V1.5C0 1.067.142.708.425.425.708.142 1.067 0 1.5 0h7.6c.2 0 .4.03.6.087.2.059.383.171.55.338l9.325 9.325c.317.317.475.688.475 1.113 0 .425-.158.795-.475 1.112l-7.6 7.6ZM10.95 18.55l7.6-7.6L9.1 1.5H1.5v7.6l9.45 9.45ZM4.125 5.4c.35 0 .654-.13.912-.388.259-.258.388-.562.388-.912s-.13-.654-.388-.912a1.248 1.248 0 0 0-.912-.388c-.35 0-.654.13-.913.388a1.248 1.248 0 0 0-.387.912c0 .35.13.654.387.913.259.258.563.387.913.387Z' />
    </svg>,
    // Items
    'item': <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 19 20'>
      <path
        d='M4.875 8.85a.735.735 0 0 1-.67-.387.666.666 0 0 1 .02-.763L8.4 1.025a.695.695 0 0 1 .622-.35c.269 0 .478.117.628.35L13.825 7.7c.167.25.173.504.02.763a.735.735 0 0 1-.67.387h-8.3ZM14.65 20c-1.233 0-2.267-.417-3.1-1.25-.833-.833-1.25-1.867-1.25-3.1s.417-2.267 1.25-3.1c.833-.833 1.867-1.25 3.1-1.25s2.267.417 3.1 1.25c.833.833 1.25 1.867 1.25 3.1s-.417 2.267-1.25 3.1c-.833.833-1.867 1.25-3.1 1.25Zm-13.9-.625a.725.725 0 0 1-.534-.216.726.726 0 0 1-.216-.534v-6.1c0-.213.072-.39.216-.534a.726.726 0 0 1 .534-.216h6.1c.213 0 .39.072.534.216a.725.725 0 0 1 .216.534v6.1c0 .212-.072.39-.216.534a.726.726 0 0 1-.534.216H.75Zm13.902-.875c.799 0 1.473-.276 2.023-.827.55-.551.825-1.226.825-2.025 0-.799-.276-1.473-.827-2.023-.551-.55-1.226-.825-2.025-.825-.799 0-1.473.276-2.023.827-.55.552-.825 1.227-.825 2.025 0 .799.276 1.473.827 2.023.551.55 1.226.825 2.025.825ZM1.5 17.875h4.6v-4.6H1.5v4.6ZM6.225 7.35h5.6l-2.8-4.525-2.8 4.525Z' />
    </svg>,
    // Offers
    'order': <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 21 21'>
      <path
        d='M11.975 19.575c-.3.3-.662.45-1.088.45-.425 0-.787-.15-1.087-.45L.425 10.2a1.312 1.312 0 0 1-.337-.525A1.885 1.885 0 0 1 0 9.1V1.5C0 1.067.142.708.425.425.708.142 1.067 0 1.5 0h7.6c.2 0 .4.03.6.087.2.059.383.171.55.338l9.325 9.325c.317.317.475.688.475 1.113 0 .425-.158.795-.475 1.112l-7.6 7.6ZM10.95 18.55l7.6-7.6L9.1 1.5H1.5v7.6l9.45 9.45ZM4.125 5.4c.35 0 .654-.13.912-.388.259-.258.388-.562.388-.912s-.13-.654-.388-.912a1.248 1.248 0 0 0-.912-.388c-.35 0-.654.13-.913.388a1.248 1.248 0 0 0-.387.912c0 .35.13.654.387.913.259.258.563.387.913.387Z' />
    </svg>,
    'offer': <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 21 21'>
      <path
        d='M11.975 19.575c-.3.3-.662.45-1.088.45-.425 0-.787-.15-1.087-.45L.425 10.2a1.312 1.312 0 0 1-.337-.525A1.885 1.885 0 0 1 0 9.1V1.5C0 1.067.142.708.425.425.708.142 1.067 0 1.5 0h7.6c.2 0 .4.03.6.087.2.059.383.171.55.338l9.325 9.325c.317.317.475.688.475 1.113 0 .425-.158.795-.475 1.112l-7.6 7.6ZM10.95 18.55l7.6-7.6L9.1 1.5H1.5v7.6l9.45 9.45ZM4.125 5.4c.35 0 .654-.13.912-.388.259-.258.388-.562.388-.912s-.13-.654-.388-.912a1.248 1.248 0 0 0-.912-.388c-.35 0-.654.13-.913.388a1.248 1.248 0 0 0-.387.912c0 .35.13.654.387.913.259.258.563.387.913.387Z' />
    </svg>,
    'credit': <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'>
      <path
        d='m7.3 20.9-1.55-2.65-3.1-.625a.731.731 0 0 1-.463-.3.653.653 0 0 1-.137-.525l.35-3-1.975-2.3a.678.678 0 0 1-.2-.5c0-.2.067-.367.2-.5L2.4 8.225l-.35-3a.653.653 0 0 1 .137-.525.732.732 0 0 1 .463-.3l3.1-.625L7.3 1.1a.8.8 0 0 1 .425-.35.702.702 0 0 1 .55.025L11 2.05 13.725.775a.743.743 0 0 1 .55-.038c.183.059.325.171.425.338l1.575 2.7 3.075.625a.732.732 0 0 1 .462.3c.125.167.171.342.138.525l-.35 3 1.975 2.275c.133.133.2.3.2.5s-.067.367-.2.5L19.6 13.8l.35 3a.653.653 0 0 1-.137.525.731.731 0 0 1-.463.3l-3.075.625-1.575 2.675a.744.744 0 0 1-.425.337.742.742 0 0 1-.55-.037L11 19.95l-2.725 1.275a.702.702 0 0 1-.55.025.8.8 0 0 1-.425-.35Zm1.025-1.375L11 18.4l2.75 1.125 1.675-2.5 2.925-.75-.3-2.975 2.025-2.3-2.025-2.35.3-2.975-2.925-.7-1.725-2.5L11 3.6 8.25 2.475l-1.675 2.5-2.925.7.3 2.975L1.925 11l2.025 2.3-.3 3.025 2.925.7 1.75 2.5Zm1.6-7.35-1.825-1.9a.712.712 0 0 0-.55-.25.834.834 0 0 0-.575.225.79.79 0 0 0-.25.575.79.79 0 0 0 .25.575L9.4 13.8a.72.72 0 0 0 .525.225.72.72 0 0 0 .525-.225l4.575-4.55a.748.748 0 0 0 .225-.55c0-.217-.083-.4-.25-.55a.735.735 0 0 0-.537-.188.738.738 0 0 0-.513.213l-4.025 4Z' />
    </svg>,
    // Earned
    'payment': <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'>
      <path
        d='M6.1 13.05c.35.767.78 1.37 1.288 1.813.508.441 1.137.762 1.887.962v.675c0 .183.07.342.213.475.141.133.304.2.487.2a.63.63 0 0 0 .475-.213.691.691 0 0 0 .2-.487v-.6c1.017-.117 1.808-.43 2.375-.938s.85-1.187.85-2.037c0-.85-.242-1.542-.725-2.075-.483-.533-1.3-1.042-2.45-1.525-.967-.4-1.667-.758-2.1-1.075a1.5 1.5 0 0 1-.65-1.275c0-.517.187-.925.562-1.225.375-.3.888-.45 1.538-.45.5 0 .933.117 1.3.35.367.233.675.583.925 1.05l1.2-.575c-.283-.583-.658-1.042-1.125-1.375-.467-.333-1.017-.533-1.65-.6v-.6a.649.649 0 0 0-.2-.475.649.649 0 0 0-.475-.2.691.691 0 0 0-.488.2.63.63 0 0 0-.212.475v.6c-.85.117-1.52.43-2.012.938S6.575 6.2 6.575 6.95c0 .817.25 1.467.75 1.95.5.483 1.25.933 2.25 1.35 1.117.467 1.883.887 2.3 1.262.417.375.625.838.625 1.388 0 .533-.22.963-.662 1.287-.442.325-.996.488-1.663.488-.65 0-1.23-.183-1.738-.55-.508-.367-.862-.867-1.062-1.5L6.1 13.05ZM10 20a9.676 9.676 0 0 1-3.875-.788 10.144 10.144 0 0 1-3.188-2.15 10.142 10.142 0 0 1-2.15-3.187A9.676 9.676 0 0 1 0 10c0-1.383.263-2.683.787-3.9a9.994 9.994 0 0 1 2.15-3.175A10.25 10.25 0 0 1 6.126.788 9.676 9.676 0 0 1 10 0c1.383 0 2.683.263 3.9.787a10.098 10.098 0 0 1 3.175 2.138c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0 1 20 10a9.676 9.676 0 0 1-.788 3.875 10.25 10.25 0 0 1-2.137 3.188 9.994 9.994 0 0 1-3.175 2.15A9.738 9.738 0 0 1 10 20Zm0-1.5c2.367 0 4.375-.83 6.025-2.488C17.675 14.354 18.5 12.35 18.5 10c0-2.367-.825-4.375-2.475-6.025C14.375 2.325 12.367 1.5 10 1.5c-2.35 0-4.354.825-6.013 2.475C2.33 5.625 1.5 7.633 1.5 10c0 2.35.83 4.354 2.487 6.012C5.646 17.671 7.65 18.5 10 18.5Z' />
    </svg>,
  };

  const typeCaptions = {
    'token': 'Offers',
    'item': 'Items',
    'order': 'Offers',
    'credit': 'Credit',
    'payment': 'Earned',
  };

  const genericThumbnail = () => {
    const available = ['blue-lamp.webp', 'golden-lamp.webp', 'green-lamp.webp', 'normal-lamp.webp'];

    return available[Math.floor(Math.random() * available.length)];
  };

  const description = () => {
    switch (activity.activity_type) {
      case 'token':
        return 'You created an offer';
      case 'item':
        return 'You created the item';
      case 'order':
        return 'You received an offer for';
      case 'offer':
        return 'You made an offer for';
      case 'credit':
        return 'You received a credit';
      case 'payment':
        return 'You received payment';
      default:
        return 'You have received an offer for your item';
    }
  };


  return (
    <tr className={`dashboard-activity__item ${activityClass(activity.activity_type)}`}>
      <td className='icon'>
        <div className='d-flex flex-column align-items-center p-0'>
          <div className='icon-activity'>
            {Iconography[activity.activity_type]}
          </div>
          <span className='mt-auto'>{typeCaptions[activity.activity_type]}</span>
        </div>
      </td>
      <td className='image'>
        <img src={activity.image} alt={activity.title} />
      </td>
      <td className='meta d-flex flex-column'>
        <div>
          <span className='date'>{activity.date}</span>
          {(activity.activity_type === 'order' || activity.activity_type === 'offer') && (
            <span className={`order-status`}> | <span
              className={activity.order_status}>{statusDescription(activity.order_status)}</span></span>
          )}
        </div>
        <span className='title'>{activity.title}</span>
        <span className='description'>{description(activity.type)}</span>
      </td>
      <td className='price'>
        {formatCurrency(activity.price, UserCountry() === 'NG' ? 'NGN' : 'USD')}
        {activity.activity_type === 'item' && (<small className="d-block" style={{fontWeight: 400, fontSize: "12px"}}>{activity.quantity} available</small>)}
      </td>
      <td className='actions text-end'>
        {activity.activity_type === 'item' && (
          <button type='button' className='btn-action primary me-2'
                  onClick={() => copyText(activity.order_alias, activity.checkout_url)}>
            {copied === true ? (
              <>Copied!</>
            ) : (
              <>Share the Item</>
            )}
          </button>
        )}

        <Link
          to={activity.order_relation === 'buyer' ? `/status/${activity.order_alias}` : `/item/manage/${activity.item_alias}`}
          className='btn-action primary opacity-50'>
          View Details
        </Link>
      </td>
    </tr>
  );
};

export default Activity;
